module.exports = __webpack_public_path__ + "847f2dbbd02885a772cc8d774a384389.png";